<div class="py-0 my-0 mx-0 px-0" style="background-color: #e9f5ff;">
  <img src="assets/images/background/login.png" class="login-background img-fluid" alt="matrix">
  <div class="login-title">
    <p class="text-title">{{'auth.login.hero' | translate}}</p>
  </div>
  <div class="login-box card">
    <div class="card-body">
      <form class="form-horizontal form-material" id="loginform">
        <img src="assets/images/trobbit-logo.png" alt="trobbit" class="mx-auto d-block trobbit-logo">
        <h4 class="box-title text-center py-4">{{'auth.resetPassword.title' | translate}}</h4>
        <div class="form-group m-b-0">
          <div class="col-sm-12 text-center">
            <div>
              <p>{{message}}</p>
            </div>
          </div>
        </div>
        <div class="form-group m-b-0" *ngIf="message===''">
          <div class="col-sm-12 text-center">
            <div class="text-left mx-5">
              <small>{{'auth.resetPassword.helpText' | translate}}</small>
            </div>
          </div>
        </div>
        <div class="form-group col-sm-12 text-center" *ngIf="message===''">
          <input [(ngModel)]="password" id="passwordInput" name="password" class="form-control input-form" type="password" required="" maxlength="20"
            (keyup)="validatePassword()" required>
          <i id="visibilityIcon" class="fa fa-eye-slash" (click)="changeVisibility()"></i>
          <small class="form-text text-danger" *ngIf="invalidPassword">{{'admin.settings.users.passwordRequirements' | translate}}</small>
        </div>
        <div class="form-group m-b-0" *ngIf="message===''">
          <div class="col-sm-12 text-center">
            <div class="text-left mx-5">
              <small>{{'auth.resetPassword.helTextRepeat' | translate}}</small>
            </div>
          </div>
        </div>

        <div class="form-group col-sm-12 text-center" *ngIf="message===''">
          <input type="password" class="form-control input-form" id="verifyPassword" [(ngModel)]="repeatPassword" (keyup)="confirmPassword()"
            name="verifyPassword" required>
          <i id="visibilityConfirmIcon" class="fa fa-eye-slash" (click)="changeVisibilityConfirm()"></i>
          <small class="form-text text-danger" *ngIf="passwordsMatch">{{'auth.resetPassword.passwordsDontMatch' | translate}}</small>
        </div>
        <div class="form-group pt-3" *ngIf="message===''">
          <div class="w-100 d-flex justify-content-center">
            <button class="btn btn-info waves-effect waves-light btn-grad" (click)="onSubmit()">
              {{'auth.resetPassword.submit' | translate}}
            </button>
          </div>
        </div>
        <div class="form-group pt-3" *ngIf="message && fail">
          <div class="w-100 d-flex justify-content-center">
            <button class="btn btn-info waves-effect waves-light btn-grad" (click)="reload()">
              {{'auth.resetPassword.tryAgain' | translate}}
            </button>
          </div>
        </div>
        <div class="form-group pt-3" *ngIf="message && !fail">
          <div class="w-100 d-flex justify-content-center">
            <button class="btn btn-info waves-effect waves-light btn-grad" [routerLink]="['/login']">>
              {{'auth.loginLink' | translate}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
